var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',[_c('div',{staticClass:"desc"},[_vm._v(" 歡迎挑戰關卡二進階版問答！遊戲限時30秒，時間內答對1題得1分，答愈多題愈高分！ ")]),_c('div',{staticClass:"button",on:{"click":function($event){return _vm.$emit('ready')}}},[_vm._v("Ready")])])}
var staticRenderFns = []

export { render, staticRenderFns }